const getURLObj = () => new URL(window.location.href)

const getParam = (name) => getURLObj().searchParams.get(name) || ''

const getAllParams = (name, value) => {
  if (!name || !value) return window.location.search || ''

  const params = getURLObj()

  params.searchParams.set(name, value)

  return `?${params.searchParams.toString()}`
}

export { getParam, getAllParams }
